import _ from 'lodash';

import type TravelerInformation from '@this/domain/traveler_information';
import type User from '@this/domain/user/user2';

interface Args {
  travelers: TravelerInformation[];
  user: User;
  foreignExist: boolean;
}

class ArrangementRequestFlightInfo {
  readonly travelers: TravelerInformation[];

  readonly user: User;

  readonly foreignExist: boolean;

  constructor(args: Args) {
    this.travelers = args.travelers;
    this.user = args.user;
    this.foreignExist = args.foreignExist;
  }

  validate(foreign?: boolean): string[] {
    const errors: { [key: string]: string | undefined } = {};
    this.travelers.forEach(t => t.flightValidate(errors, foreign === undefined ? this.foreignExist : foreign));
    return _.compact(Object.keys(errors).map(k => errors[k]));
  }
}

export default ArrangementRequestFlightInfo;
